import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Label } from "../Label/Label";
import { InputMessageGroup } from "../InputMessageGroup/InputMessageGroup";
export const RadioGroup = ({ label, subtitle, errorMessage, hasErrors, required, orientation, hideLabel, onChange, valueSelected, message, children, className, name, ...rest }) => {
    const [selected, setSelected] = React.useState(valueSelected);
    React.useEffect(() => {
        setSelected(valueSelected);
    }, [valueSelected]);
    const handleChange = e => {
        var _a;
        setSelected((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
        if (onChange) {
            onChange(e);
        }
    };
    const getRadios = () => React.Children.map(children, (radio) => {
        var _a, _b;
        if (!radio)
            return null;
        return React.cloneElement(radio, {
            name,
            key: `${name}-${(_a = radio === null || radio === void 0 ? void 0 : radio.props) === null || _a === void 0 ? void 0 : _a.id}`,
            onChange: handleChange,
            checked: ((_b = radio === null || radio === void 0 ? void 0 : radio.props) === null || _b === void 0 ? void 0 : _b.value) === selected,
            required,
            "aria-describedby": `${name}-meta`,
        });
    });
    return (_jsxs("div", { children: [_jsx(Label, { id: `${name}__label`, font: "title-6", screenReaderOnly: hideLabel, hasErrors: hasErrors, children: label }), subtitle && (_jsx(Label, { id: `${name}__subtitle`, font: "body-3", color: "text-secondary", children: subtitle })), _jsx("div", { className: classNames("eds-radio-group", { "eds-radio-group--horizontal": orientation === "horizontal" }, className), role: "radiogroup", "aria-labelledby": `${name}__label ${name}__subtitle`, ...rest, children: getRadios() }), (message || hasErrors) && (_jsx(InputMessageGroup, { id: `${name}-meta`, message: message, errorMessage: hasErrors && (errorMessage || "Error") }))] }));
};
